import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import MyAppBar from '../../components/MyAppBar';
import { CircularProgress, Container, Paper, Typography } from '@mui/material';
import LakeMakeupTable from '../../components/LakeMakeupTable';

const styles = {
  container: {
    padding: 1,
  },
  paper: {
    margin: 2,
    padding: 4,
  },
  indent: {
    paddingLeft: 5,
  },
};

function sortFunc(a, b) {
  if (a.Permittee > b.Permittee) return 1;
  if (a.Permittee < b.Permittee) return -1;
  return 0;
}

export default function H(props) {
  const { yearmonth } = useParams();
  const [year, month] = yearmonth.split('-');
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);

  useEffect(() => {
    const getCases = async () => {
      setLoading(true);
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/lakeMakeup/${year}/${month}`
      );
      const casesResult = await response.json();
      casesResult.sort(sortFunc);
      setCases(casesResult);
      setLoading(false);
    };
    getCases();
  }, [month, year]);

  return (
    <React.Fragment>
      <MyAppBar title='Appendix H - Lake Makeup Report' />
      <Container sx={styles.container}>
        <Paper sx={styles.paper}>
          {loading && <CircularProgress />}
          {!loading && cases.length === 0 ? (
            <Typography variant='h6'>None</Typography>
          ) : (
            <LakeMakeupTable permits={cases} />
          )}
        </Paper>
      </Container>
    </React.Fragment>
  );
}
